import React, { Component } from "react"
import PropTypes from 'prop-types'
import * as moment from 'moment';

import { withTranslation } from "react-i18next"

class LiVerticalTimeline extends Component {
  render() {
    return (
      <React.Fragment>
        <li className="event-list">
          <div className="event-timeline-dot">
            <i
              className={
                this.props.status.id === 1
                  ? "bx bx-right-arrow-circle bx-fade-right"
                  : "bx bx-right-arrow-circle"
              }
            />
          </div>
          <div className="media">
            <div className="me-3">
              <i
                className={ this.props.status.iconClass}
              />
            </div>
            <div className="media-body">
              <div>
                <h5>{this.props.t(this.props.status.statusTitle)}</h5>
                <p className="text-muted mb-0">{this.props.t(this.props.status.description)}</p>
                <p className="text-muted mb-2">{this.props.status.data || ""}</p>
                <p className="text-muted mb-2">{this.props.status.user || ""}</p>
                <p className="mb-0 text-secondary">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {moment(this.props.status.time).fromNow()}{" "}
                        </p>
              </div>
            </div>
          </div>
        </li>
      </React.Fragment>
    )
  }
}

LiVerticalTimeline.propTypes = {
  status: PropTypes.object,
  t: PropTypes.any
}


export default withTranslation()(LiVerticalTimeline);